import styled from 'styled-components';

export const StyledSettingButton = styled.button`
  cursor: pointer;
  background-color: transparent;
  display: flex;
  align-items: center;
  padding: 0;
  border: none;
  margin-right: 1.6rem;
`;

export const SettingButtonImg = styled.img`
  width: 2.4rem;
  height: 2.4rem;
`;
